import {Injectable} from '@angular/core';
import {PlanningParameterItem} from './planning-parameter-item';
import {Observable} from 'rxjs';
import {PlanningParameter} from '../planning-parameter/planning-parameter';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';
import * as classTransformer from 'class-transformer';
import {PlanningParameterItemCollection} from './planning-parameter-item-collection';
import {Item} from '../item/item';

@Injectable({
    providedIn: 'root',
})
export class PlanningParameterItemService {

    constructor(private httpClient: HttpClient) {
    }

    public update(planningParameter: PlanningParameter, updatedItems: Item[]): Observable<PlanningParameterItemCollection> {
        const params: { id: string }[] = [];

        updatedItems.forEach(item => {
            params.push({ id: item.id });
        })

        return this.httpClient
            .put('/planning-parameters/' + planningParameter.id + '/items', params)
            .pipe(map((result: any) => {
                const collection = new PlanningParameterItemCollection();
                collection.setTotalItems(result['totalItems']);
                collection.setPlanningParameterItems(
                    result['member'].map((itemData: any) => classTransformer.plainToInstance(PlanningParameterItem, itemData))
                );

                return collection;
            }));
    }
}
